module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Regular.eot?f9dfe06c56139128d11a9e030c1a4330";